import { Action, createReducer, on } from '@ngrx/store';
import { fromEmployeeWithdrawalsActions } from '../actions';

export const markAsRequestedKey = 'markAsRequested';

export interface EmployeeWithdrawalMarkAsRequestedState {
  markAsRequestedResponse: { success: boolean };
  markAsRequestedFailure: Error | any;
}

export const initialState: EmployeeWithdrawalMarkAsRequestedState = {
  markAsRequestedResponse: undefined,
  markAsRequestedFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromEmployeeWithdrawalsActions.markAsRequestedResponse, (state, action) => ({
    ...state,
    markAsRequestedResponse: action.response
  })),
  on(fromEmployeeWithdrawalsActions.markAsRequestedFailure, (state, action) => ({
    ...state,
    markAsRequestedFailure: action.error
  }))
);
